import React, { useState, useEffect } from 'react';

import { ResultProvider } from '../../dataProvider/results';
import { getResultOrigin } from '../../dataProvider/origin';
import { getPlace } from '../../dataProvider/places';
import { getData } from '../../dataProvider/places/single';
import { TYPES, SUBTYPES } from '../../envs/core';
import './horizontalGraphContainer.scss';
import Header from '../../components/header';
import HorizontalGraph from './../../components/horizontalGraph';

const HorizontalGraphContainer = ({ match }) => {
  const { year, electionNumber, town } = match.params;
  const [selectedProvinceCapital, setSelectedProvinceCapital] = useState({});

  const [resultOrigin, setResultOrigin] = useState({});

  useEffect(() => {
    getResultOrigin(
      year,
      TYPES.MUNICIPAL,
      electionNumber,
      town.toLowerCase() === 'barcelona' ? '08' : 'C108'
    )
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, electionNumber]);

  useEffect(() => {
    getPlace(
      `sortby=main&size=1&parentid=${
        town.toLowerCase() === 'barcelona' ? '08' : '28'
      }`
    ).then(place => {
      setSelectedProvinceCapital(place.content[0]);
      console.log(getData(place.content[0].ineId));
      return getData(place.content[0].ineId);
    });
  }, [town]);

  return (
    <div className="horizontalGraphPage">
      <Header>
        <h2>
          ELECCIONES 26M: AYTO. DE{' '}
          {town.toLowerCase() === 'barcelona' ? 'Barcelona' : 'Madrid'}
        </h2>
      </Header>
      <div className="horizontalGraphContainer">
        {resultOrigin &&
          resultOrigin.primary &&
          (console.log(selectedProvinceCapital),
          (
            <ResultProvider
              active={resultOrigin.primary.active}
              year={year}
              type={TYPES.MUNICIPAL}
              subtype={SUBTYPES.SINGLE}
              electionNumber={electionNumber}
              placeId={selectedProvinceCapital.ineId}
              details={true}
            >
              {dataResult => (
                <HorizontalGraph
                  data={dataResult.partiesResult || []}
                  dataKey="seats"
                  showLabel={true}
                  showFaces={true}
                  seatTotal={dataResult.totalSeats || 0}
                  total={dataResult.totalSeats || 0}
                  place={selectedProvinceCapital.ineId}
                />
              )}
            </ResultProvider>
          ))}
      </div>
    </div>
  );
};

export default HorizontalGraphContainer;
